async function t(t){const e=await t.request({method:"eth_gasPrice"});return BigInt(e)}export{t as getGasPrice};
